<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <!-- 头部 -->
    <div class="titleView">
      <div style="margin-right: 20px; display: flex; align-items: center">
        <el-input
          v-model="keyWord"
          prefix-icon="el-icon-search"
          placeholder="商品/条码/分拨单号"
          class="titleInput"
          clearable
          size="small"
        />
        <el-button
          type="warning"
          style="margin-left: 10px"
          @click="handleChange"
          size="small"
          >搜索</el-button
        >
      </div>
      <div class="flex" v-if="tabs == 1 || tabs == 2 || tabs == 3">
        <div style="margin-right: 10px">申请日期</div>
        <el-date-picker
          v-model="dateValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="titleDate"
          @change="handleChange"
          :default-time="['00:00:00', '23:59:59']"
          value-format="timestamp"
          style="width: 224px"
          size="small"
        />
      </div>

      <div class="flex" v-if="tabs == 4">
        <div style="margin-right: 10px">验收状态</div>
        <el-select
          v-model="acceptance_state"
          placeholder="请选择"
          class="titleSelect"
          @change="handleChange"
          style="width: 126px"
          size="small"
        >
          <el-option
            v-for="item in acceptanceState"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="flex">
        <el-button @click="handleResetClick" size="small">重置</el-button>
      </div>
      <div
        style="text-align: right; flex: 1"
        v-if="tabs == 1 || tabs == 2 || tabs == 3"
      >
        <!-- <el-button type="primary">添加新品</el-button> -->
        <el-button @click="handleAddClick" size="small">新建采购单</el-button>
      </div>
    </div>
    <!-- tab切换 -->
    <!-- <div class="tabView">
			<el-button :class="tabs == 1?'active':'noactive'" @click="handleTabClick(1)" size="small">采购中</el-button>
			<el-button :class="tabs == 2?'active':'noactive'" @click="handleTabClick(2)" size="small">采购完成</el-button>
			<el-button :class="tabs == 3?'active':'noactive'" @click="handleTabClick(3)" size="small">采购取消</el-button>
		</div> -->

    <div class="tabLine">
      <div
        class="tabItem"
        :class="[tabs == 1 ? 'active' : '']"
        @click="handleTabClick(1)"
      >
        采购中
      </div>
      <div
        class="tabItem"
        :class="[tabs == 2 ? 'active' : '']"
        @click="handleTabClick(2)"
      >
        采购完成
      </div>
      <div
        class="tabItem"
        :class="[tabs == 3 ? 'active' : '']"
        @click="handleTabClick(3)"
      >
        采购取消
      </div>
    </div>
    <!-- 表格 -->
    <div class="tableView">
      <el-table
        :data="tableData"
        style="width: 100%"
        size="small"
        v-if="tabs == 1 || tabs == 2 || tabs == 3"
        key="1"
      >
        <el-table-column prop="procureNo" label="采购批次号" :key="1" />
        <el-table-column
          prop="createOperationInfo.operationTime"
          label="采购申请日期"
          :key="2"
        />
        <el-table-column
          prop="createOperationInfo.userName"
          label="采购人"
          :key="3"
        />
        <!-- <el-table-column label="关联门店" :key="5" :formatter="shopsFormat" /> -->
        <!-- <el-table-column
          prop="success_time"
          label="采购完成日期"
          :key="6"
          v-if="tabs == 2"
        /> -->
        <!-- <el-table-column
          prop="date"
          label="取消日期"
          :key="7"
          v-if="tabs == 3"
        /> -->
        <el-table-column
          prop="count"
          label="采购数量"
          :key="8"
          align="center"
        />

        <el-table-column
          prop="remarks"
          label="备注"
          :key="10"
          align="center"
          v-if="tabs == 1"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.remarks == "" ? "--" : scope.row.remarks
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" :key="11" align="center">
          <template slot-scope="scope">
            <el-button
              @click="handleSetClick(scope.row)"
              type="text"
              size="small"
              >{{ tabs == 1 ? "编辑" : "查看" }}
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleCanleClick(scope.row)"
              v-if="tabs == 1"
              >取消
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <page
        :page="page.page"
        :total="page.total"
        @change="changePage"
        style="padding: 10px 0"
      ></page>
    </div>
    <el-dialog
      title="是否取消该次采购单"
      :visible.sync="dialogFormVisible"
      width="557px"
    >
      <el-input
        v-model="cancelValue"
        autocomplete="off"
        type="textarea"
        placeholder="请输入5字以上"
        show-word-limit
        rows="6"
        resize="none"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleComClick">确 定</el-button>
      </div>
    </el-dialog>
  
  </div>
</template>
<script>
import { caigouList,cancelCaigou} from "@/api/purchaseApiNew.js"
import { getDistributionInfo } from "@/api/shopPurchaseApi.js";
import page from "../../../components/page.vue";
export default {
  components: {
    page,
  },
  data() {
    return {
      fixedHeight: "",
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      keyWord: "",
      cancelValue: "", //取消理由
      dialogFormVisible: false,
      tableData: [], //商品数据
      tabs: 1,
      serchValue: "", //输入框筛选
      dateValue: null, //采购申请日期
      shopValue: "", //门店筛选
      textValue: "", //取消理由
      cancelId: "", //取消采购单id
      acceptance_state: -1, //分拨状态
      acceptanceState: [
        {
          //门店筛选
          value: -1,
          label: "全部",
        },
        {
          value: 1,
          label: "已验收",
        },
        {
          value: 2,
          label: "部分验收",
        },
        {
          value: 3,
          label: "未验收",
        },
        {
          value: 4,
          label: "未配送",
        },
        {
          value: 5,
          label: "配送中",
        },
        {
          value: 6,
          label: "已送达",
        },
      ],
      allocation_staff_id: "", //配送员id
      dialogaccept: false,
      inspectionDetail: "",
      sumData: [],
      showType: {
        showType0: true,
        showType1: true,
        showType7: true,
        showType3: true,
      },
      deliveryName: "",
      staffList: [],
      staffId: "",
      distribution_no: "",
      deliveryType: 0,
    };
  },
  created() {
    let that = this;
    this.fixedHeight = document.documentElement.clientHeight - 76;
    document.onkeydown = function () {
      var key = window.event.keyCode;
      if (key == 13) {
        that.getTableData();
      }
    };
  },
  computed: {

  },
  mounted() {
    if (sessionStorage.getItem("cgtabs")) {
      console.log("缓存", sessionStorage.getItem("cgtabs"));
      this.tabs = sessionStorage.getItem("cgtabs");
      this.serchValue = "";
      this.dateValue = null;
      this.shopValue = "";
      this.page = {
        page: 1,
        pageSize: 10,
        total: 0,
      };
    }
    this.getTableData();
    sessionStorage.removeItem("cgtabs");
  },
  methods: {
    handleShopClick(type) {
      this.showType["showType" + type] = !this.showType["showType" + type];
    },
    fillterGoodsCustom(arry) {
      let custtomList = arry.filter((item) => {
        return item.is_check == true || item.goods_state == 4;
      });

      return custtomList;
    },
    toogleExpand(row) {
      let $table = this.$refs["table" + row.goods.goods_type][0];
      $table.toggleRowExpansion(row);
    },
    sumGoods(arry) {
      let sumData = [];
      arry.forEach((item) => {
        let index = sumData.findIndex((ele) => {
          return item.goods.goods_type == ele.goods_type;
        });
        if (index == -1) {
          sumData.push({
            goods_type: item.goods.goods_type,
            goods: [item],
          });
        } else {
          sumData[index].goods.push(item);
        }
      });
      return sumData;
    },
    inspectionLook(id) {
      getDistributionInfo({
        distribution_no: id,
      }).then((res) => {
        if (res.code == 0) {
          this.inspectionDetail = res.data;
          this.sumData = this.sumGoods(res.data.linkData);
          console.log("数据", this.sumData);
        }
      });
      this.dialogaccept = true;
    },
    //编辑
    handleSetClick(row) {
      console.log(row.procureNo,"rowwwwww-----");
      let query = {
        id: row.procureNo,
        cgtabs: this.tabs,
      };
      if (this.tabs == 1) {
        console.log("采购中");
        this.$router.push({
          path: "cgzDetail",
          query,
        });
      }
      if (this.tabs == 2) {
        console.log("采购完成");
        this.$router.push({
          path: "cgwcDetail",
          query,
        });
      }
      if (this.tabs == 3) {
        console.log("采购取消");
        this.$router.push({
          path: "cgwcDetail",
          query,
        });
      }
    },
    //取消采购单确认按钮
    handleComClick() {
      if (this.cancelValue.length < 5) {
        this.$message({
          message: "请输入5字以上",
          type: "warning",
        });
        return;
      }
      let parmars = {
        id: this.cancelId,
        remark: this.cancelValue,
      };
      cancelCaigou(parmars).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "已取消",
            type: "success",
          });
          this.dialogFormVisible = false;
          this.textValue = "";
          this.getTableData();
        }
      });
    },
    // //格式化门店
    // shopsFormat(row) {
    //   console.log(row.procure_request_simples_list.length)
    //   if (row.procure_request_simples_list.length == 0) {
    //     return "总部";
    //   } else {
    //     let storeStr = "";
    //     let storeArr = [];
    //     for (let i = 0; i < row.procure_request_simples_list.length; i++) {
    //       switch (
    //         row.procure_request_simples_list[i].createOperationInfo.company_info.shop_id
    //       ) {
    //         case "5e9412e0b2bfbc089daerr12":
    //           storeArr.push("金水区店 ");
    //           break;
    //         case "5e9412e0b2bfbc089daerr13":
    //           storeArr.push("陇海店 ");
    //           break;
    //         case "5e9412e0b2bfbc089daerr14":
    //           storeArr.push("指挥中心店 ");
    //           break;
    //         case "5e9412e0b2bfbc089daerr15":
    //           storeArr.push("东区店 ");
    //           break;
    //         case "5e9412e0b2bfbc089daerr17":
    //           storeArr.push("线上旗舰店 ");
    //           break;
    //         case "5e9412e0b2bfbc089daerr16":
    //           storeArr.push("拓展部 ");
    //           break;
    //         case "5e9412e0b2bfbc089daerr10":
    //           storeArr.push("驯养中心 ");
    //           break;
    //           case "5e9412e0b2bfbc089daerr18":
    //           storeArr.push("郑东新区店");
    //           break;
    //         case "5e9412e0b2bfbc089daerr11":
    //           storeArr.push("小程序 ");
    //           break;
    //       }
    //     }
    //     storeArr = [...new Set(storeArr)];
    //     for (let j = 0; j < storeArr.length; j++) {
    //       storeStr += storeArr[j];
    //     }
    //     // console.log(storeArr,storeStr);
    //     return storeStr;
    //   }
    // },
    //新建采购单
    handleAddClick() {
      this.$router.push({
        path: "addcaigou",
      });
    },
 
    // 取消按钮
    handleCanleClick(row) {
      console.log(row,row);
      this.dialogFormVisible = true;
      this.cancelId = row.procureNo;
    },
    //重置
    handleResetClick() {
      this.keyWord = "";
      this.shopValue = "";
      if (this.tabs == 1 || this.tabs == 2 || this.tabs == 3) {
        this.dateValue = null;
        this.getTableData();
      } 
    },
    //tab切换
    handleTabClick(index) {
      this.tabs = index;
      this.serchValue = "";

      this.shopValue = "";
      this.page.page = 1;
      if (this.tabs == 1 || this.tabs == 2 || this.tabs == 3) {
        this.dateValue = null;
        this.getTableData();
      }
    },
    //筛选切换
    handleChange() {
      if (this.tabs == 1 || this.tabs == 2 || this.tabs == 3) {
        this.getTableData();
      }
    },
    //分页方法
    changePage(num) {
      this.page.page = num;
      if (this.tabs == 1 || this.tabs == 2 || this.tabs == 3) {
        this.getTableData();
      }
    },
    //获取商品详情
    getTableData() {
      // console.log(this.serchValue)
      let stateStr = 0;
      if (this.tabs == 1) {
        stateStr = 1;
      } else if (this.tabs == 2) {
        stateStr = 3;
      } 
      let startTime = "";
      let endTime = "";
      if (this.dateValue != null) {
        startTime = this.dateValue[0] / 1000;
        endTime = this.dateValue[1] / 1000;
      } else {
        startTime = "";
        endTime = "";
      }
      let parmars = {
        pageIndex: this.page.page, //当前页
        pageSize: this.page.pageSize, //每页条数
        keyWord: this.keyWord, //关键字
        state: stateStr, //状态   1采购中  3采购完成 4采购取消
        shopId: this.shopValue, //门店id
        startTime: this.$public.FTime(startTime), //开始时间
        endTime: this.$public.FTime(endTime), //结束时间
      };
      caigouList(parmars).then((res) => {
        if (res.code == 0) {
          console.log("商品列表11", res);
          this.tableData = res.data.list;
          this.page.total = res.data.count;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  display: flex;
  flex-direction: column;

  .flex {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .titleView {
    background: #fff;
    height: 72px;
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 0 10px;
  }

  .tabLine {
    display: flex;
    margin: 10px 0;

    .tabItem {
      width: 100px;
      box-sizing: border-box;
      line-height: 36px;
      text-align: center;
      border-right: 1px solid #f2f2f2;
      cursor: pointer;
      font-size: 14px;
      background-color: #fff;

      &.active {
        color: $mainColor;
      }
    }
  }

  .tabView {
    margin: 20px 0;
  }

  .tableView {
    flex: 1;
    background: #fff;
    overflow: hidden;
  }

  .active {
    background: #f5882a;
    color: #fff;
  }

  .noactive {
    background: #fff;
    color: #000;
  }

  .titlecon {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex: 1;
    background-color: #f5f5f5;
    padding: 5px 0;
    border-radius: 5px;

    .titleleft {
      span {
        margin: 5px 20px;
        display: inline-block;
      }
    }

    .titleright {
      width: 300px;
      // margin-top: 20px;
    }
  }

  .comH2 {
    line-height: 64px;
    font-size: 18px;
    display: flex;
    align-items: center;
  }
}
</style>
